import Emittery from 'emittery';

export const emittery = new Emittery();
